<template>
  <div>
    <delete-question-modal
      :question="selectedQuestion"
      @deleted="fetchQuestions"
    />
    <view-question-modal
      :question="selectedQuestionForView"
    />

    <b-button
      class="mb-2"
      variant="primary"
      @click="handleAddQuestion"
    >
      <span class="text-nowrap">Add Question</span>
    </b-button>

    <b-card class="mb-0">
      <b-table
        hover
        striped
        :items="getQuestionsList"
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="No questions found"
      >
        <template #cell(text)="data">
          <span class="font-weight-medium">{{ data.item.text || '-' }}</span>
        </template>

        <template #cell(text_ar)="data">
          <span class="text-muted">{{ data.item.text_ar || '-' }}</span>
        </template>

        <template #cell(updated_at)="data">
          {{ formatDate(data.item.updated_at) }}
        </template>

        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            right
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item @click="handleViewQuestion(data.item)">
              <feather-icon
                icon="EyeIcon"
                size="16"
                class="align-middle mr-1"
              />
              <span class="align-middle">View Answers</span>
            </b-dropdown-item>
            <b-dropdown-item @click="handleEditQuestion(data.item)">
              <feather-icon
                icon="EditIcon"
                size="16"
                class="align-middle mr-1"
              />
              <span class="align-middle">Edit</span>
            </b-dropdown-item>
            <b-dropdown-item @click="handleDeleteQuestion(data.item)">
              <feather-icon
                icon="TrashIcon"
                size="16"
                class="align-middle mr-1"
              />
              <span class="align-middle">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BDropdown,
  BDropdownItem,
  BButton,
  BCard,
} from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import quizStore from '../store'
import useQuizList from '../hooks/useQuizList'
import DeleteQuestionModal from './DeleteQuestionModal.vue'
import ViewQuestionModal from './ViewQuestionModal.vue'

export default {
  components: {
    BTable,
    BDropdown,
    BDropdownItem,
    BButton,
    BCard,
    DeleteQuestionModal,
    ViewQuestionModal,
  },
  setup(props, ctx) {
    useRegisterStoreModule('learningCenterQuiz', quizStore)

    const {
      tableColumns,
      questionsLoading,
      fetchQuestions,
      getQuestionsList,
    } = useQuizList(ctx)

    const selectedQuestion = ref({})
    const selectedQuestionForView = ref({})

    watch(questionsLoading, () => {
      ctx.emit('questions-loading-state', questionsLoading.value)
    }, { immediate: true })

    const handleAddQuestion = () => {
      ctx.root.$router.push('/learning-center-quiz/new')
    }

    const handleViewQuestion = question => {
      selectedQuestionForView.value = question
      ctx.root.$bvModal.show('view-question-modal')
    }

    const handleEditQuestion = question => {
      ctx.root.$router.push(`/learning-center-quiz/edit/${question.id}`)
    }

    const handleDeleteQuestion = question => {
      selectedQuestion.value = question
      ctx.root.$bvModal.show('delete-question-modal')
    }

    const formatDate = dateString => {
      if (!dateString) return '-'
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    }

    return {
      tableColumns,
      questionsLoading,
      fetchQuestions,
      getQuestionsList,
      selectedQuestion,
      selectedQuestionForView,
      handleAddQuestion,
      handleViewQuestion,
      handleEditQuestion,
      handleDeleteQuestion,
      formatDate,
    }
  },
}
</script>
